<template>
  <div
    :class="{dimmed: disabled || busy}"
    v-b-tooltip.hover
    :title="(compact) ? label : undefined"
  >
    <b-spinner small v-if="busy" />
    <IconRedo v-else class="fill-color" />
    <span v-if="!compact" class="ml-2">{{ label }}</span>
  </div>
</template>

<script>
import { http } from '@/services/http.js'
import { isGetty } from '@/components/MediaRelated.vue'
import { pollForUpdate } from '@/services/media.js'
import IconRedo from '@primer/octicons/build/svg/redo-16.svg'

export default {
  name: 'QuickMenuReprocess',
  components: {
    IconRedo,
  },
  props: {
    item: Object,
    compact: Boolean,
  },
  data() {
    return {
      busy: false,
    }
  },
  computed: {
    disabled() {
      return isGetty(this.item) || !this.item?.id
    },
    label() {
      if (isGetty(this.item)) {
        return 'Getty results cannot be re-processed.'
      }
      return 'Re-process'
    },
  },
  methods: {
    async toggle() {
      if (this.disabled || this.busy) return
      this.busy = true
      try {
        this.$set(this.item, '_processing', 'Re-processing...')
        await http.post(`/api/images/${this.item.id}/reprocess/`, {})
        const response = await pollForUpdate(this.item)
        Object.assign(this.item, response.data, {_processing: false})
        this.$bvToast.toast(`Processed ${this.item.id}`, {
          variant: 'success',
          noCloseButton: true,
          solid: true,
        })
      } catch (err) {
        const msg = err?.response?.data ? JSON.stringify(err.response.data) : err
        this.$set(this.item, '_processing', `Processing failed: ${msg}`)
      } finally {
        this.busy = false
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.dimmed {
  opacity: $btn-disabled-opacity;
}
</style>
